
<div class="content-wrapper pt-2"> 
  <section class="content">
   
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Payment</div> 
      <form [formGroup]="paymentForm"  autocomplete="off"  class="form-horizontal">   
      <div class="card-body">   
          
        <div class="row">    
          <div class="col-md-4">
            <div class="form-group">
              <label for="voucherNo" class="col-form-label">Voucher No</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                </div>
                <input type="text"   [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="voucherNo" class="form-control field-bg-color" [class.is-invalid]="formErrors.voucherNo" (blur)="logValidationErrors()" placeholder="Voucher No">
              </div>
              <span class="text-danger" *ngIf="formErrors.voucherNo"><small>{{formErrors.voucherNo}}</small> </span>   
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="paidDate" class="col-form-label">Paid Date </label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"   [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-calendar-alt"></i></span>
                </div>
                <input type="text"   [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="paidDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.paidDate" (blur)="logValidationErrors()" placeholder="Paid Date">
              </div>
              <span class="text-danger" *ngIf="formErrors.paidDate"><small>{{formErrors.paidDate}}</small> </span>   
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="paymentType" class="col-form-label">Payment Type</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"   [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                </div>
                <select  [ngClass]="{'dark-input-field' : isDark }" formControlName="paymentType" class="form-control field-bg-color" [class.is-invalid]="formErrors.paymentType" (blur)="logValidationErrors()">        
                  <option [ngValue]="null">-Select-</option>
                  <option *ngFor="let item of PMT_TYPE" [value]="item.value">
                    {{item.value}}
                  </option>
              </select>
              </div>
              <span class="text-danger" *ngIf="formErrors.paymentType"><small>{{formErrors.paymentType}}</small> </span>   
            </div>
          </div>
     

        </div>


        <div class="row"> 

            <div class="form-group">
            <input  name="supId" readonly formControlName="supId" [(ngModel)]="payment.supId"  class="form-control"    type="hidden">
             </div> 
             <div class="col-md-5">
              <div class="form-group">
                <label for="supName" class="col-form-label">Supplier</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"   [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                  </div>
                  <input   [ngClass]="{'dark-input-field' : isDark }" type="text" formControlName="supName" (focusout)="getSupplierDetails()"  [matAutocomplete]="auto" class="form-control field-bg-color"  [class.is-invalid]="formErrors.supName" (blur)="logValidationErrors()" placeholder="Supplier Name">
                  <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option.SupName">
                      {{option.SupName}}
                    </mat-option>
                  </mat-autocomplete>                
                </div>
                <span class="text-danger" *ngIf="formErrors.supName"><small>{{formErrors.supName}}</small> </span>               
              </div>
            </div>

          <div class="col-md-7">
            <div class="form-group">
              <label for="address" class="col-form-label">Address</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                </div>
                <input  [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control field-bg-color" formControlName="address" [(ngModel)]="payment.address" id="address" [class.is-invalid]="formErrors.address" (blur)="logValidationErrors()" placeholder="Address">
              </div>
              <span class="text-danger" *ngIf="formErrors.address"><small>{{formErrors.address}}</small> </span>   
            </div>
          </div> 

      </div>

      <div class="row"> 

        <div class="col-md-6">
          <div class="form-group">
            <label for="paymentAccount" class="col-form-label">Payment Account</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
              </div>
              <select  [ngClass]="{'dark-input-field' : isDark }" formControlName="paymentAccount" class="form-control field-bg-color" [class.is-invalid]="formErrors.paymentAccount" (blur)="logValidationErrors()">        
                <option [ngValue]="null">-Select-</option>
                <option *ngFor="let item of bankAccountList" [value]="item.AccountName">
                  {{item.AccountName}}
                </option>
            </select>
            </div>
            <span class="text-danger" *ngIf="formErrors.paymentAccount"><small>{{formErrors.paymentAccount}}</small> </span>   
          </div>
        </div>

          <div class="col-md-3">
              <div class="form-group">
                <label for="payRefNo" class="col-form-label">Payment Ref No.</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                  </div>
                  <input  [ngClass]="{'dark-input-field' : isDark }" type="text"  formControlName="payRefNo" class="form-control field-bg-color"  placeholder="Pay Ref No">
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="paidTotal" class="col-form-label">Paid Total</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }">Rs.</span>
                  </div>
                  <input  [ngClass]="{'dark-input-field' : isDark }" type="text" readonly  formControlName="paidTotal" class="form-control field-bg-color"  placeholder="Paid Total">
                </div>
              </div>
            </div>


      </div>


      <div class="row"> 
          <div class="col-md-12">
              <table class="table table-sm  mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
                  <thead class="thead-light" [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
                      <tr>
                        <th scope="col">InvoiceDate</th>
                        <th scope="col">InvoiceNo</th>
                        <th scope="col">InvoiceTotal</th>
                        <th scope="col">BalToPay</th>
                        <th scope="col">AmountPaid</th>
                        <th style="width: 8%"  scope="col">Select</th>
                      </tr>
                    </thead>


                  <tbody class="ml-1" formArrayName="unpaidInvoices" *ngFor="let Item of paymentForm.get('unpaidInvoices')['controls']; let i = index">                    
                      
                        <tr [formGroupName] = "i" >                           
                            <td><input  [ngClass]="{'dark-input-field' : isDark }" type="text" readonly class="form-control form-control-sm" formControlName="grnDate"></td>                   
                            <td><input  [ngClass]="{'dark-input-field' : isDark }" type="text" readonly class="form-control form-control-sm" formControlName="grnNo"></td>  
                            <td><input  [ngClass]="{'dark-input-field' : isDark }" type="text" style="text-align: right"  readonly class="form-control form-control-sm" formControlName="invoiceTotal"></td>  
                            <td><input  [ngClass]="{'dark-input-field' : isDark }" type="text" style="text-align: right"  readonly class="form-control form-control-sm" formControlName="balToPay"></td>  
                            <td class="d-none"><input type="hidden"  readonly class="form-control form-control-sm" formControlName="accAmountPaid"></td>  
                            <td><input  [ngClass]="{'dark-input-field' : isDark }" type="text" style="text-align: right"  readonly class="form-control form-control-sm" formControlName="amountPaid"></td>  
                            <td class="p-2">
                              <mat-checkbox (change)="selectInvoiceCheckBoxChange($event,i)"  formControlName="select"></mat-checkbox>
                             <button (click)="attachReceiptFileButtonClick(Item)" mat-icon-button class="icon-button-small text-success ml-2"><mat-icon>add_link</mat-icon></button>
                            </td>                   
                          </tr>  
                                                        
                  </tbody>
              </table> 
  
          </div> 
      </div>

      </div>  
     <!-- /.card-body -->
        
      <div class="card-footer">
      <button *ngIf="crud_access.create"  type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>
        <button *ngIf="crud_access.create"  type="button" [disabled]="isBtnDisabled"  (click)="saveButtonClick()" class="btn btn-info ml-2">
         <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          Save
        </button>
        <button *ngIf="crud_access.delete"  class="btn btn-danger ml-2" [disabled]="!isBtnDisabled" (click)="deleteButtonClick()">Cancel</button>
        <button class="btn btn-success ml-2" routerLink="../payment-list"><i class="fa fa-table p-1"></i>Payment List</button>
        <button  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
        <button (click)="loadInvoiceButtonClick()" [disabled]="isBtnDisabled" mat-raised-button color="accent" class="ml-2">Load Outstaning Invoices</button>
     
        <button (click)="savePDF('print')"  mat-icon-button class="text-info float-right">
          <mat-icon>print</mat-icon>
        </button>
        <button (click)="savePDF('download')"  mat-icon-button class="text-success float-right">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button (click)="savePDF('open')"  mat-icon-button class="text-dark float-right">
          <mat-icon [ngClass]="{'dark-bg' : isDark }">preview</mat-icon>
        </button>
     
      </div>

      </form>
    </div>

  </section>
<!-- Form Values : {{ paymentForm.value | json }}  -->
</div> 



